<template>
  <div id="tabManagers">
    <div class="margin-subpages">
      <div
        v-if="
          Object.keys(this.checked).filter((k) => this.checked[k] === true)
            .length == 0
        "
        class="flex-row-center height-bind"
      >
        <div class="flex-center-1 fs-24 f-000000">
          <span class="fw-900">{{
            managersall.length > 0
              ? $utils("addCommasInNumber", managersall.length)
              : 0
          }}</span>
          <span class="fw-600">&nbsp;{{ $t("members.Managers") }}</span>
        </div>
      </div>
      <div
        v-else
        class="flex-row-center height-bind selectionmenu"
        style="background-color: #6c30cc; margin: -10px -40px 0"
      >
        <span class="fs-18 fc-FFFFFF fw-700 ml-40"
          >{{
            Object.keys(this.checked).filter((k) => this.checked[k] === true)
              .length
          }}
          {{ $t("members.managers_selected") }}</span
        >
        <div style="margin-left: 24px; display: flex">
          <div v-for="(item, index) in this.checkedData" :key="index">
            <div v-if="index < 3">
              <img
                v-if="item.pic"
                v-lazy="item.pic"
                class="viewMember image-skeleton image-profile-30"
                :class="[ blurMode ?  'blurelement': '' ]"
                v-bind:style="renderSelectedPic(index)"
              />
              <div
                v-else
                class="viewMember image image-profile-30"
                :class="[ blurMode ?  'blurelement': '' ]"
                v-bind:style="renderSelectedPic(index)"
              >
                <div class="text-in-image text-in-image-30 flex-mid">
                  {{
                    $utils("acronymName", {
                      firstName: item.firstname,
                      lastName: item.lastname,
                    })
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <span
          v-if="this.checkedData.length > 3"
          class="fs-14 fc-FFFFFF"
          style="margin-left: -10px"
          >+{{
            this.checkedData && this.checkedData.length > 3
              ? this.checkedData.length - 3
              : ""
          }}</span
        >

        <div class="divActionHeader">
          <div
            class="btn btn-navbar bg-hover-barken-54279B"
            @click.prevent="
              reAssignManagerModalStatus = !reAssignManagerModalStatus
            "
            @click="reAssignManagerModalClick"
          >
            {{ $t("members.RE_ASSIGN_MANAGER") }}
          </div>
        </div>
      </div>
      <div class="flex-row-between mt-14">
        <el-input
          class="input-style"
          autosize
          :placeholder="$t('members.Search')"
          v-model="inputSearch"
          clearable
        ></el-input>
        <div style="width: 220px">
          <el-menu class="input-select" mode="horizontal">
            <el-submenu index="0" style="width: 220px">
              <template slot="title">
                <span class="text-dropdown" id="managerSortBy">{{
                  $t("members.Sort_by_Name")
                }}</span>
              </template>
              <el-menu-item
                index="1"
                @click="sortBy('name')"
                style="font-size: 14px; width: 220px"
                >{{ $t("members.Sort_by_Name") }}</el-menu-item
              >
              <el-menu-item
                index="2"
                @click="sortBy('direct')"
                style="font-size: 14px; width: 220px"
                >{{ $t("members.Sort_by_Direct_Reports") }}</el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="mt-20">
        <el-table
          ref="multipleTable"
          :data="managers"
          style="width: 100%"
          @row-click="rowClickEdit"
          :row-style="tableRowStyle"
          :empty-text="
            loadingManagersTable
              ? ' '
              : !loadingManagersTable && inputSearch === ''
              ? 'No managers'
              : 'No results found...'
          "
          :header-cell-style="tableHeaderStyle"
        >
          <el-table-column width="45" column-key="memberCheckbox">
            <template slot-scope="scope">
              <el-checkbox
                :disabled="!subManagerByKey[scope.row.email]"
                class="mr-10"
                style="display: inline-block; float: right"
                v-model="checked['key_' + scope.row.key]"
                :key="scope.row.key"
                @change="membersChecked(scope.row.key)"
              />
            </template>
          </el-table-column>

          <el-table-column width="58">
            <template slot-scope="scope">
              <div class="absolute-mid">
                <div v-if="scope.row.pic">
                  <img
                    v-lazy="scope.row.pic"
                    :key="scope.row.pic"
                    class="image-skeleton image-profile-42 flex-mid"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                </div>
                <div v-else class="image image-profile-42"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <div class="text-in-image text-in-image-42 flex-mid">
                    {{
                      $utils("acronymName", {
                        firstName: scope.row.firstname,
                        lastName: scope.row.lastname,
                      })
                    }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('members.Manager')" width="230">
            <template slot-scope="scope">
              <div class="flex-column">
                <span class="text-name"
                :class="[ blurMode ?  'blurelement': '' ]"
                  >{{ scope.row.firstname }} {{ scope.row.lastname }}</span
                >
                <span class="text-email"
                :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.email }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('members.Team')" width="250">
            <template slot-scope="scope">
              <span v-if="scope.row.team_name"
              :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.team_name }}</span>
              <span v-else class="fc-32c2d5 fs-14"
              :class="[ blurMode ?  'blurelement': '' ]">{{
                $t("members.Assign_Team")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('members.Status')" align="center">
            <template slot-scope="scope">
              <div class="div-active">
                <div
                  class="btn-status mx-auto"
                  :class="[`status-${scope.row.status}`]"
                >
                  {{ scope.row.status }}
                </div>
                <div class="active">{{ scope.row.to_now }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('members.Direct_Reports')"
            width="220"
            align="right"
          >
            <template slot-scope="scope">
              <div class="flex-row-center" style="float: right">
                <span class="fs-14 fc-4A4A4A pr-10">{{
                  subManagerByKey[scope.row.email]
                    ? subManagerByKey[scope.row.email].length
                    : ""
                }}</span>
                <div
                  style="display: flex"
                  :style="
                    renderDirectReportWidth(
                      subManagerByKey[scope.row.email].length
                    )
                  "
                >
                  <div
                    :key="index"
                    v-for="(item, index) in subManagerByKey[scope.row.email]"
                  >
                    <div v-if="index < 3">
                      <img
                        v-if="item.pic"
                        v-lazy="item.pic"
                        class="view-member image-skeleton image-profile-30"
                        :class="[ blurMode ?  'blurelement': '' ]"
                        :style="renderDirectReportPic(index)"
                      />
                      <div
                        v-else
                        class="view-member image image-profile-32"
                        :class="[ blurMode ?  'blurelement': '' ]"
                        v-bind:style="renderDirectReportPic(index)"
                      >
                        <div class="text-in-image text-in-image-32 flex-mid">
                          {{
                            $utils("acronymName", {
                              firstName: item.firstname,
                              lastName: item.lastname,
                            })
                          }}
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="index == 3"
                      class="view-member image image-profile-32"
                      :style="renderDirectReportPic(index)"
                    >
                      <div
                        class="text-in-image text-in-image-32 flex-mid"
                        style="
                          font-weight: 700;
                          font-size: 12px;
                          padding-top: 2px;
                        "
                      >
                        {{
                          subManagerByKey[scope.row.email] &&
                          subManagerByKey[scope.row.email].length > 3
                            ? "+" +
                              (subManagerByKey[scope.row.email].length - 3)
                            : ""
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <span
                  v-if="
                    subManagerByKey[scope.row.email] &&
                    subManagerByKey[scope.row.email].length > 3
                  "
                  class="fw-700 fs-14 fc-4A4A4A"
                  style="margin-left: -13px"
                >
                  {{
                    subManagerByKey[scope.row.email] &&
                    subManagerByKey[scope.row.email].length > 3
                      ? "+" + (subManagerByKey[scope.row.email].length - 3)
                      : ""
                  }}
                </span> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          v-if="loadingManagersTable"
          class="relative opa-08"
          style="margin-top: -60px; z-index: 99"
        >
          <div
            v-for="value in [1, 2, 3, 4, 5]"
            :key="'mock_data_on_loading_' + value"
            class="flex-center"
            :class="{
              'opa-02': value == 5,
              'opa-04': value == 4,
              'opa-06': value == 3,
            }"
            style="height: 64px"
          >
            <div class="flex-mid opa-04" style="width: 54px">
              <el-checkbox
                style="display: inline-block; float: right; margin-right: 6px"
              />
            </div>
            <div class="flex-mid" style="width: 42px">
              <div class="image-skeleton image-profile-42 opa-06"></div>
            </div>
            <div class="pl-18" style="width: 220px">
              <div class="text-skeleton fs-14" style="width: 140px">&nbsp;</div>
              <div class="text-skeleton fs-14 opa-06 mt-6" style="width: 120px">
                &nbsp;
              </div>
            </div>
            <div class="flex-center" style="width: 250px">
              <div class="text-skeleton fs-14 ml-10" style="width: 100px">
                &nbsp;
              </div>
            </div>
            <div class="flex-mid" style="width: 94px">
              <div class="div-active">
                <div class="btn-status opa-06" style="padding-top: 0">
                  &nbsp;
                </div>
                <div
                  class="text-skeleton fs-8 mt-3 mx-auto"
                  style="width: 50px"
                >
                  &nbsp;
                </div>
              </div>
            </div>
            <div
              class="flex-mid ml-auto opa-06"
              style="width: 80px; margin-right: -10px"
            >
              <div
                :key="index + 'mock_member_of_team'"
                v-for="index in [1, 2, 3]"
              >
                <div
                  class="view-member image-skeleton image-profile-30"
                  :style="renderDirectReportPic(index)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loadingManagersTable" class="mt-10 pagination flex-center">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next"
          :total="results"
        ></el-pagination>
        <span class="results-status">
          {{ managers.length > 10 ? 10 : managers.length }}
          {{ $t("members.results_from") }} {{ results }}
          {{ $t("members.results") }}
        </span>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogFormVisible"
      top="8vh"
      @close="cancelDialog"
    >
      <el-form :model="validateForm" ref="validateForm">
        <el-col
          :span="13"
          class="thin-scrollbar"
          style="height: 84vh; min-height: 847px; max-height: 1200px"
          v-if="dialogFormVisible"
        >
          <member
            :userDetail="validateForm"
            :orgChartData="modalMemberData['org']"
            :powerData="powerData"
            :modalMemberData="modalMemberData"
          ></member>
        </el-col>
        <el-col :span="11" class="second-column profileform thin-scrollbar">
          <div id="modal_profile" class="px-40 pb-40" style="padding-top: 60px">
            <div
              v-if="
                directReportsData.total == 0 ||
                directReportsData.total == undefined
              "
            >
              <div v-if="switchToArchive" class="mt-24">
                <div>
                  <span class="fw-700 fs-19 fc-2D2E36">{{
                    $t("members.Are_you_sure_would")
                  }}</span>
                </div>
                <div class="pt-20">
                  <span class="fs-16 fc-2D2E36">{{
                    $t("members.Once_archived_the_member")
                  }}</span>
                </div>
                <div class="pt-20">
                  <span class="fs-16 fc-2D2E36">{{
                    $t("members.Archived_members_can_be")
                  }}</span>
                </div>
                <el-col :span="24" class="flex-center mt-40">
                  <el-button
                    class="btnArchiveModal"
                    @click="archiveMemberClick"
                  >
                    <div class="flex-center" style="justify-content: center">
                      <img
                        :src="getImgUrl('ic_archive-24px@2x')"
                        style="width: 18px; height: 18px"
                      />
                      <span class="fs-15 fw-700" style="padding-left: 8px">{{
                        $t("members.ARCHIVE")
                      }}</span>
                    </div>
                  </el-button>
                  <el-button
                    class="btnCancelArchiveModal btn-gray"
                    type="primary"
                    @click="switchToArchive = !switchToArchive"
                    >{{ $t("members.CANCEL") }}</el-button
                  >
                </el-col>
              </div>
              <div v-else class="mt-24">
                <el-col :span="11">
                  <p class="txtHeaderStyle">{{ $t("members.First_Name") }}</p>
                  <el-input
                    v-model="validateForm.firstname"
                    auto-complete="off"
                    :placeholder="$t('members.First_Name')"
                  ></el-input>
                </el-col>
                <el-col :span="1">&nbsp;</el-col>
                <el-col :span="12">
                  <p class="txtHeaderStyle">{{ $t("members.Last_Name") }}</p>
                  <el-input
                    v-model="validateForm.lastname"
                    auto-complete="off"
                    :placeholder="$t('members.Last_Name')"
                  ></el-input>
                </el-col>
                <el-col :span="24" style="padding-top: 12px">
                  <p class="txtHeaderStyle">{{ $t("members.Email") }}</p>
                  <el-input
                    :disabled="this.mode ? true : false"
                    v-model="validateForm.email"
                    auto-complete="off"
                    placeholder="name@company.com"
                  ></el-input>
                </el-col>
                <el-col :span="24" style="padding-top: 32px">
                  <p class="txtHeaderStyle">{{ $t("members.Manager") }}</p>
                  <el-autocomplete
                    class="inline-input managerfield"
                    v-model="validateForm.dispboss"
                    :fetch-suggestions="querySearchManager"
                    :placeholder="$t('members.Select_a_Manager')"
                    @select="handleSelectManager"
                    @input="handleInputManager"
                    :trigger-on-focus="false"
                    style="width: 100%"
                  >
                    <template slot-scope="{ item }">
                      <div class="flex-center my-7">
                        <div v-if="item.pic">
                          <img
                            v-lazy="item.pic"
                            :key="item.pic"
                            class="
                              image-skeleton image-profile-32
                              flex-mid
                              mr-12
                            "
                            :class="[ blurMode ?  'blurelement': '' ]"
                          />
                        </div>
                        <div
                          v-else
                          class="image image-profile-32 flex-mid mr-12"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        >
                          <div class="text-in-image text-in-image-32 flex-mid">
                            {{
                              $utils("acronymName", {
                                firstName: item.firstname,
                                lastName: item.lastname,
                              })
                            }}
                          </div>
                        </div>
                        <div style="width: 200px; line-height: 16px">
                          <div class="ellipsis">
                            {{ item.firstname + " " + item.lastname }}
                          </div>
                          <div class="ellipsis fs-13 opa-06">
                            {{ item.firstname + " " + item.lastname }}
                          </div>
                        </div>
                        <div
                          style="
                            display: flex;
                            flex: 1;
                            justify-content: flex-end;
                          "
                        >
                          <div class="div-active">
                            <div
                              class="btn-status"
                              :class="[`status-${item.status}`]"
                            >
                              {{ item.status }}
                            </div>
                            <div class="active">{{ item.to_now }}</div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template slot="prepend">
                      <div class="autocomplete-member">
                        <img
                          v-if="validateForm.boss_pic"
                          v-lazy="validateForm.boss_pic"
                          class="
                            image image-skeleton image-profile-52
                            flex-mid
                            mr-12
                          "
                          :class="[ blurMode ?  'blurelement': '' ]"
                        />
                        <div
                          v-else
                          class="image image-profile-52 flex-mid mr-12"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        >
                          <div class="text-in-image text-in-image-52 flex-mid">
                            {{
                              $utils("acronymName", {
                                firstName: validateForm.boss_firstname,
                                lastName: validateForm.boss_lastname,
                              })
                            }}
                          </div>
                        </div>
                        <div class="team-name">
                          {{ validateForm.dispteam }}
                        </div>
                      </div>
                    </template>
                  </el-autocomplete>
                  <div class="flex-right">
                    <div
                      v-if="validateForm.dispmanager"
                      style="justify-content: flex-end"
                    >
                      <p
                        class="fs-12 fc-F44336 m-0 pt-6"
                        style="word-break: normal"
                      >
                        {{ validateForm.dispmanager }}
                      </p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="24" style="padding-top: 12px">
                  <div class="flex-center">
                    <div class="flex-center-1">
                      <p class="txtHeaderStyle">Team</p>
                    </div>
                  </div>
                  <el-autocomplete
                    class="inline-input teamfield"
                    :class="
                      validateForm.team_color
                        ? `border-left-color-${validateForm.team_color}`
                        : 'border-left-color-'
                    "
                    v-model="validateForm.dispteam"
                    :fetch-suggestions="querySearchTeam"
                    :placeholder="$t('members.Select_a_Team')"
                    @select="handleSelectTeam"
                    @input="handleInputTeam"
                    style="width: 100%"
                  >
                    <template slot-scope="{ item }">
                      <div class="item">{{ item.name }}</div>
                    </template>
                  </el-autocomplete>
                  <div class="flex-right">
                    <div
                      v-if="
                        validateForm.dispteam &&
                        Object.keys(teamByKey).filter(
                          (k) =>
                            teamByKey[k].name.toLowerCase() ===
                            validateForm.dispteam.toLowerCase()
                        ).length == 0
                      "
                      style="justify-content: flex-end"
                    >
                      <p
                        class="fs-12 fc-32C2D5 m-0 pt-6"
                        style="word-break: normal"
                      >
                        “{{ validateForm.dispteam }}”
                        {{ $t("members.will_be_created_as_a") }}
                      </p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="24" style="padding-top: 32px">
                  <p class="txtHeaderStyle">{{ $t("members.User_role") }}</p>
                  <el-select
                    v-model="validateForm.user_type"
                    class="rolefield"
                    style="width: 100%"
                  >
                    <el-option label="👩🏻  Member" value="user">
                      <span style="float: left; color: #2d2e36; font-size: 14px"
                        >👩🏻 Member</span
                      >
                      <span style="float: right; font-size: 11px">{{
                        $t("members.Limited_Access")
                      }}</span>
                    </el-option>
                    <el-option label="✍🏻  Admin" value="admin">
                      <span style="float: left; color: #2d2e36; font-size: 14px"
                        >✍🏻 Admin</span
                      >
                      <span style="float: right; font-size: 11px">{{
                        $t("members.Manage_Account_Email_Notifications")
                      }}</span>
                    </el-option>
                    <el-option label="👩🏻‍💻  HR" value="hr">
                      <span style="float: left; color: #2d2e36; font-size: 14px"
                        >👩🏻‍💻 HR</span
                      >
                      <span style="float: right; font-size: 11px">{{
                        $t("members.Manage_Account_Insights")
                      }}</span>
                    </el-option>
                    <el-option label="👩🏻‍💼  Leader" value="leadership">
                      <span style="float: left; color: #2d2e36; font-size: 14px"
                        >👩🏻‍💼 Leader</span
                      >
                      <span style="float: right; font-size: 11px">{{
                        $t("members.Insights_Medals")
                      }}</span>
                    </el-option>
                    <el-option label="🦸🏻‍♀️  Super Leader" value="superleader">
                      <span style="float: left; color: #2d2e36; font-size: 14px"
                        >🦸🏻‍♀️ Super Leader</span
                      >
                      <span style="float: right; font-size: 11px">{{
                        $t("members.Manage_Account_Insights_Medals")
                      }}</span>
                    </el-option>
                    <el-option label="🙆🏻‍♀️  Super Admin" value="superadmin">
                      <span style="float: left; color: #2d2e36; font-size: 14px"
                        >🙆🏻‍♀️ Super Admin</span
                      >
                      <span style="float: right; font-size: 11px">{{
                        $t("members.Manage_Account_Insights_Email")
                      }}</span>
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="24" style="padding-top: 12px">
                  <p class="txtHeaderStyle">{{ $t("members.Language") }}</p>
                  <el-select
                    v-model="validateForm.language"
                    class="langfield"
                    style="width: 100%"
                  >
                    <el-option
                      :label="$t('members.English')"
                      value="en"
                    ></el-option>
                    <el-option
                      :label="$t('members.Thai')"
                      value="th"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="24" class="flex-center mt-32">
                  <el-button class="btnAddMemberModal" @click="saveMember">{{
                    $t("members.SAVE_CHANGES")
                  }}</el-button>
                  <el-button
                    :disabled="this.mode ? false : true"
                    class="btnInviteMemberModal btn-gray"
                    type="primary"
                    @click="inviteMember(validateForm.email)"
                  >
                    <div class="flex-center" style="justify-content: center">
                      <img
                        :src="getImgUrl('ic_mail-18px@2x')"
                        style="width: 18px; height: 18px"
                      />
                      <span style="padding-left: 8px">{{
                        $t("members.SEND_INVITE")
                      }}</span>
                    </div>
                  </el-button>
                </el-col>
                <!-- <el-col v-if="this.mode" :span="24" style="padding-top: 13px;">
                  <span
                    class="txtArchivedModal"
                    @click="switchToArchive = !switchToArchive"
                  >{{ $t("members.Archive_employee") }}</span>
                </el-col> -->
              </div>
            </div>
            <div v-else>
              <el-tabs v-model="activeProfileTab">
                <el-tab-pane
                  :label="$t('members.Information')"
                  name="information"
                >
                  <div v-if="switchToArchive" class="mt-24">
                    <div>
                      <span class="fw-700 fs-19 fc-2D2E36">{{
                        $t("members.Are_you_sure_would")
                      }}</span>
                    </div>
                    <div class="pt-20">
                      <span class="fs-16 fc-2D2E36">{{
                        $t("members.Once_archived_the_member")
                      }}</span>
                    </div>
                    <div class="pt-20">
                      <span class="fs-16 fc-2D2E36">{{
                        $t("members.Archived_members_can_be")
                      }}</span>
                    </div>
                    <el-col :span="24" class="flex-center mt-40">
                      <el-button
                        class="btnArchiveModal"
                        @click="archiveMemberClick"
                      >
                        <div
                          class="flex-center"
                          style="justify-content: center"
                        >
                          <img
                            :src="getImgUrl('ic_archive-24px@2x')"
                            style="width: 18px; height: 18px"
                          />
                          <span
                            class="fs-15 fw-700"
                            style="padding-left: 8px"
                            >{{ $t("members.ARCHIVE") }}</span
                          >
                        </div>
                      </el-button>
                      <el-button
                        class="btnCancelArchiveModal btn-gray"
                        type="primary"
                        @click="switchToArchive = !switchToArchive"
                        >{{ $t("members.CANCEL") }}</el-button
                      >
                    </el-col>
                  </div>
                  <div v-else class="mt-24">
                    <el-col :span="11">
                      <p class="txtHeaderStyle">
                        {{ $t("members.First_Name") }}
                      </p>
                      <el-input
                        v-model="validateForm.firstname"
                        auto-complete="off"
                        :placeholder="$t('members.First_Name')"
                        :class="[ blurMode ?  'blurelement': '' ]"
                      ></el-input>
                    </el-col>
                    <el-col :span="1">&nbsp;</el-col>
                    <el-col :span="12">
                      <p class="txtHeaderStyle">
                        {{ $t("members.Last_Name") }}
                      </p>
                      <el-input
                        v-model="validateForm.lastname"
                        auto-complete="off"
                        :placeholder="$t('members.Last_Name')"
                        :class="[ blurMode ?  'blurelement': '' ]"
                      ></el-input>
                    </el-col>

                    <el-col :span="24" style="padding-top: 12px">
                      <p class="txtHeaderStyle">{{ $t("members.Email") }}</p>
                      <el-input
                        :disabled="this.mode ? true : false"
                        v-model="validateForm.email"
                        auto-complete="off"
                        placeholder="name@company.com"
                        :class="[ blurMode ?  'blurelement': '' ]"
                      ></el-input>
                    </el-col>

                    <el-col :span="24" style="padding-top: 32px">
                      <p class="txtHeaderStyle">{{ $t("members.Manager") }}</p>
                      <el-autocomplete
                        class="inline-input managerfield"
                        v-model="validateForm.dispboss"
                        :fetch-suggestions="querySearchManager"
                        :placeholder="$t('members.Select_a_Manager')"
                        @select="handleSelectManager"
                        @input="handleInputManager"
                        :trigger-on-focus="false"
                        style="width: 100%"
                        :class="[ blurMode ?  'blurelement': '' ]"
                      >
                        <template slot-scope="{ item }">
                          <div class="flex-center my-7">
                            <div v-if="item.pic">
                              <img
                                v-lazy="item.pic"
                                :key="item.pic"
                                class="
                                  image-skeleton image-profile-32
                                  flex-mid
                                  mr-12
                                "
                                :class="[ blurMode ?  'blurelement': '' ]"
                              />
                            </div>
                            <div
                              v-else
                              class="image image-profile-32 flex-mid mr-12"
                              :class="[ blurMode ?  'blurelement': '' ]"
                            >
                              <div
                                class="text-in-image text-in-image-32 flex-mid"
                              >
                                {{
                                  $utils("acronymName", {
                                    firstName: item.firstname,
                                    lastName: item.lastname,
                                  })
                                }}
                              </div>
                            </div>
                            <div style="width: 200px; line-height: 16px">
                              <div class="ellipsis">
                                {{ item.firstname + " " + item.lastname }}
                              </div>
                              <div class="ellipsis fs-13 opa-06">
                                {{ item.firstname + " " + item.lastname }}
                              </div>
                            </div>
                            <div
                              style="
                                display: flex;
                                flex: 1;
                                justify-content: flex-end;
                              "
                            >
                              <div class="div-active">
                                <div
                                  class="btn-status"
                                  :class="[`status-${item.status}`]"
                                >
                                  {{ item.status }}
                                </div>
                                <div class="active">{{ item.to_now }}</div>
                              </div>
                            </div>
                          </div>
                        </template>
                        <template slot="prepend">
                          <div class="autocomplete-member">
                            <img
                              v-if="validateForm.boss_pic"
                              v-lazy="validateForm.boss_pic"
                              class="
                                image image-skeleton image-profile-52
                                flex-mid
                                mr-12
                              "
                              :class="[ blurMode ?  'blurelement': '' ]"
                            />
                            <div
                              v-else
                              class="image image-profile-52 flex-mid mr-12"
                              :class="[ blurMode ?  'blurelement': '' ]"
                            >
                              <div
                                class="text-in-image text-in-image-52 flex-mid"
                              >
                                {{
                                  $utils("acronymName", {
                                    firstName: validateForm.boss_firstname,
                                    lastName: validateForm.boss_lastname,
                                  })
                                }}
                              </div>
                            </div>
                            <div class="team-name">
                              {{ validateForm.dispteam }}
                            </div>
                          </div>
                        </template>
                      </el-autocomplete>
                      <div class="flex-right">
                        <div
                          v-if="validateForm.dispmanager"
                          style="justify-content: flex-end"
                        >
                          <p
                            class="fs-12 fc-F44336 m-0 pt-6"
                            style="word-break: normal"
                          >
                            {{ validateForm.dispmanager }}
                          </p>
                        </div>
                      </div>
                    </el-col>

                    <el-col :span="24" style="padding-top: 12px">
                      <div class="flex-center">
                        <div class="flex-center-1">
                          <p class="txtHeaderStyle">Team</p>
                        </div>
                      </div>
                      <el-autocomplete
                        class="inline-input teamfield"
                        :class="
                          [validateForm.team_color
                          ? `border-left-color-${validateForm.team_color}`
                          : 'border-left-color-',
                          blurMode ? 'blurelement': ''
                      ]"
                        v-model="validateForm.dispteam"
                        :fetch-suggestions="querySearchTeam"
                        :placeholder="$t('members.Select_a_Team')"
                        @select="handleSelectTeam"
                        @input="handleInputTeam"
                        style="width: 100%"
                      >
                        <template slot-scope="{ item }">
                          <div class="item"
                          :class="[ blurMode ?  'blurelement': '' ]">{{ item.name }}</div>
                        </template>
                      </el-autocomplete>
                      <div class="flex-right">
                        <div
                          v-if="
                            validateForm.dispteam &&
                            Object.keys(teamByKey).filter(
                              (k) =>
                                teamByKey[k].name.toLowerCase() ===
                                validateForm.dispteam.toLowerCase()
                            ).length == 0
                          "
                          style="justify-content: flex-end"
                        >
                          <p
                            class="fs-12 fc-32C2D5 m-0 pt-6"
                            style="word-break: normal"
                          >
                            “{{ validateForm.dispteam }}”
                            {{ $t("members.will_be_created_as_a") }}
                          </p>
                        </div>
                      </div>
                    </el-col>

                    <el-col :span="24" style="padding-top: 32px">
                      <p class="txtHeaderStyle">
                        {{ $t("members.User_role") }}
                      </p>
                      <el-select
                        v-model="validateForm.user_type"
                        class="rolefield"
                        style="width: 100%"
                      >
                        <el-option label="👩🏻  Member" value="user">
                          <span
                            style="float: left; color: #2d2e36; font-size: 14px"
                            >👩🏻 Member</span
                          >
                          <span style="float: right; font-size: 11px">{{
                            $t("members.Limited_Access")
                          }}</span>
                        </el-option>
                        <el-option label="✍🏻  Admin" value="admin">
                          <span
                            style="float: left; color: #2d2e36; font-size: 14px"
                            >✍🏻 Admin</span
                          >
                          <span style="float: right; font-size: 11px">{{
                            $t("members.Manage_Account_Email_Notifications")
                          }}</span>
                        </el-option>
                        <el-option label="👩🏻‍💻  HR" value="hr">
                          <span
                            style="float: left; color: #2d2e36; font-size: 14px"
                            >👩🏻‍💻 HR</span
                          >
                          <span style="float: right; font-size: 11px">{{
                            $t("members.Manage_Account_Insights")
                          }}</span>
                        </el-option>
                        <el-option label="👩🏻‍💼  Leader" value="leadership">
                          <span
                            style="float: left; color: #2d2e36; font-size: 14px"
                            >👩🏻‍💼 Leader</span
                          >
                          <span style="float: right; font-size: 11px">{{
                            $t("members.Insights_Medals")
                          }}</span>
                        </el-option>
                        <el-option label="🦸🏻‍♀️  Super Leader" value="superleader">
                          <span
                            style="float: left; color: #2d2e36; font-size: 14px"
                            >🦸🏻‍♀️ Super Leader</span
                          >
                          <span style="float: right; font-size: 11px">{{
                            $t("members.Manage_Account_Insights_Medals")
                          }}</span>
                        </el-option>
                        <el-option label="🙆🏻‍♀️  Super Admin" value="superadmin">
                          <span
                            style="float: left; color: #2d2e36; font-size: 14px"
                            >🙆🏻‍♀️ Super Admin</span
                          >
                          <span style="float: right; font-size: 11px">{{
                            $t("members.Manage_Account_Insights_Email")
                          }}</span>
                        </el-option>
                      </el-select>
                    </el-col>

                    <el-col :span="24" style="padding-top: 12px">
                      <p class="txtHeaderStyle">{{ $t("members.Language") }}</p>
                      <el-select
                        v-model="validateForm.language"
                        class="langfield"
                        style="width: 100%"
                      >
                        <el-option
                          :label="$t('members.English')"
                          value="en"
                        ></el-option>
                        <el-option
                          :label="$t('members.Thai')"
                          value="th"
                        ></el-option>
                      </el-select>
                    </el-col>

                    <el-col :span="24" style="padding-top: 12px">
                      <div class="grid-2-50">
                        <div class="mr-8">
                          <p class="txtHeaderStyle">Country</p>
                          <el-select
                            v-model="validateForm.country"
                            class="langfield"
                            style="width: 100%"
                            filterable
                          >
                            <el-option
                              v-for="item in locationOption"
                              :key="item.value"
                              :label="item.value"
                              :value="item.lable"
                            ></el-option>
                          </el-select>
                        </div>
                        <div class="ml-8">
                          <p class="txtHeaderStyle">Time Zone</p>
                          <el-select
                            v-model="validateForm.time_zone"
                            class="langfield"
                            style="width: 100%"
                          >
                            <el-option
                              v-for="item in timeZoneOption"
                              :key="item.lable"
                              :label="item.utcOffsetStr"
                              :value="item.lable"
                              style="height: auto"
                            >
                              <span style="line-height: 14px">
                                <div class="mt-8" style="max-width: 350px">
                                  {{ item.utcOffsetStr }}
                                </div>
                                <el-tooltip
                                  v-if="item.country.length > 46"
                                  placement="top"
                                >
                                  <div slot="content" style="max-width: 520px">
                                    {{ item.country }}
                                  </div>
                                  <div
                                    class="opa-08 fs-12 mb-8 mt-2 ellipsis"
                                    style="max-width: 350px"
                                  >
                                    {{ item.country }}
                                  </div>
                                </el-tooltip>
                                <div
                                  v-else
                                  class="opa-08 fs-12 mb-8 mt-2 ellipsis"
                                  style="max-width: 350px"
                                >
                                  {{ item.country }}
                                </div>
                              </span>
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </el-col>

                    <el-col v-if="mode" :span="24" class="flex-center mt-32">
                      <el-button
                        class="btnAddMemberModal"
                        @click="saveMember"
                        >{{ $t("members.SAVE_CHANGES") }}</el-button
                      >
                      <el-button
                        :disabled="this.mode ? false : true"
                        class="btnInviteMemberModal btn-gray"
                        type="primary"
                        @click="inviteMember(validateForm.email)"
                      >
                        <div
                          class="flex-center"
                          style="justify-content: center"
                        >
                          <img
                            :src="getImgUrl('ic_mail-18px@2x')"
                            style="width: 18px; height: 18px"
                          />
                          <span style="padding-left: 8px">{{
                            $t("members.SEND_INVITE")
                          }}</span>
                        </div>
                      </el-button>
                    </el-col>

                    <el-col v-else :span="24" class="flex-center mt-32">
                      <div class="flex-center">
                        <el-button
                          class="btnAddMemberModal"
                          @click="saveMember"
                          >{{ $t("members.ADD_MEMBER") }}</el-button
                        >
                        <div class="send-style ml-28">
                          <el-checkbox v-model="checkedAutoSendInvit"
                            ><span></span
                          ></el-checkbox>
                        </div>
                        <div class="fs-13 fw-400 fc-2D2E36">
                          {{ $t("members.Automatically_send_an") }}
                        </div>
                      </div>
                    </el-col>
                  </div>
                </el-tab-pane>
                <el-tab-pane
                  :label="`${$t('members.Direct_Reports')} (${
                    directReportsData.total
                  })`"
                  name="directReports"
                  :disabled="directReportsData.total == 0 ? true : false"
                >
                  <div class="mt-24">
                    <div class="fs-20 fw-900 fc-2D2E36 mb-16">
                      {{ $t("members.Direct_Reports") }} ({{
                        directReportsData.total
                      }})
                    </div>
                    <div
                      v-for="profile in directReportsData.directReport"
                      :key="profile.id"
                      class="flex-center py-8"
                    >
                      <div class="flex-mid">
                        <img
                          v-if="profile.pic"
                          v-lazy="profile.pic"
                          :alt="profile.firstname + ' ' + profile.lastName"
                          :key="profile.pic"
                          class="image-skeleton image-profile-42 flex-mid mr-12"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        />
                        <div
                          v-else
                          class="image image-profile-42 flex-mid mr-12"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        >
                          <div class="text-in-image text-in-image-42 flex-mid">
                            {{
                              $utils("acronymName", {
                                firstName: profile.firstname,
                                lastName: profile.lastname,
                              })
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="flex-column">
                        <span class="text-name"
                        :class="[ blurMode ?  'blurelement': '' ]"
                          >{{ profile.firstname }} {{ profile.lastname }}</span
                        >
                        <span class="text-email"
                        :class="[ blurMode ?  'blurelement': '' ]">{{ profile.email }}</span>
                      </div>
                      <div
                        class="fs-14 fc-4A4A4A ml-16 ellipsis"
                        :class="[ blurMode ?  'blurelement': '' ]"
                        style="width: 114px"
                      >
                        {{ profile.team_name }}
                      </div>
                      <div class="div-active" style="margin-left: auto">
                        <div
                          class="btn-status"
                          :class="[`status-${profile.status}`]"
                        >
                          {{ profile.status }}
                        </div>
                        <div class="active">{{ profile.to_now }}</div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </el-col>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="reAssignManagerModalStatus"
      @close="cancelReAssignManagerModal"
      top="8vh"
    >
      <el-col :span="8" class="first-column-modal rm-scrollbar">
        <div class="fs-20 fc-2D2E36 fw-700 mb-6">
          {{
            subCheckedData.length > 0
              ? $utils("addCommasInNumber", subCheckedData.length)
              : 0
          }}
          {{ $t("members.managers_selected") }}
        </div>
        <div
          v-for="(user, index) in subCheckedData"
          :key="index + user.email"
          class="flex-center py-8"
        >
          <div class="flex-mid">
            <img
              v-if="user.pic"
              v-lazy="user.pic"
              :alt="user.firstname + ' ' + user.lastname"
              :key="user.pic"
              class="image-skeleton image-profile-42 flex-mid mr-12"
              :class="[ blurMode ?  'blurelement': '' ]"
            />
            <div v-else class="image image-profile-42 flex-mid mr-12"
            :class="[ blurMode ?  'blurelement': '' ]">
              <div class="text-in-image text-in-image-42 flex-mid">
                {{
                  $utils("acronymName", {
                    firstName: user.firstname,
                    lastName: user.lastname,
                  })
                }}
              </div>
            </div>
          </div>
          <div class="flex-column">
            <span class="text-name"
            :class="[ blurMode ?  'blurelement': '' ]"
              >{{ user.firstname }} {{ user.lastname }}</span
            >
            <span class="text-email"
            :class="[ blurMode ?  'blurelement': '' ]">{{ user.email }}</span>
          </div>
        </div>
      </el-col>
      <el-col :span="16" class="second-column-modal">
        <div class="fs-24 fc-2D2E36 fw-700 mb-20">
          {{ $t("members.Re_Assign_Manager") }}
        </div>
        <el-input
          class="input-style"
          v-model="manager_assign_disp"
          auto-complete="off"
          :placeholder="$t('members.Search_manager_name')"
          @input="handleInputManagerAssign"
        ></el-input>
        <div class="fs-14 fc-4A4A4A my-24">
          {{ $t("members.Suggestions_based_on_member") }}
        </div>
        <div class="grid-2">
          <div
            v-for="(item, index) in this.managerSuggest"
            :key="index"
            class="card bd-r-3 cursor-pointer"
            @click="assignManagerActiveClick(item, index)"
            :class="{ 'active-card': selectedManagerForReAssign === index }"
          >
            <div class="flex-center">
              <div class="flex-mid">
                <img
                  v-if="item.pic"
                  v-lazy="item.pic"
                  :alt="item.firstname + item.lastname"
                  :key="item.pic"
                  class="image-skeleton image-profile-40 flex-mid mr-12"
                  :class="[ blurMode ?  'blurelement': '' ]"
                />
                <div v-else class="image image-profile-40 flex-mid mr-12"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <div class="text-in-image text-in-image-40 flex-mid">
                    {{
                      $utils("acronymName", {
                        firstName: item.firstname,
                        lastName: item.lastname,
                      })
                    }}
                  </div>
                </div>
              </div>
              <div class="flex-column">
                <span class="text-name"
                :class="[ blurMode ?  'blurelement': '' ]"
                  >{{ item.firstname }} {{ item.lastname }}</span
                >
                <span class="text-email"
                :class="[ blurMode ?  'blurelement': '' ]">{{ item.email }}</span>
              </div>
              <div class="div-active" style="margin-left: auto">
                <div class="btn-status" :class="[`status-${item.status}`]">
                  {{ item.status }}
                </div>
                <div class="active">{{ item.to_now }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-reverse mt-30">
          <el-button
            class="btn primary"
            style="margin-left: 12px"
            @click="reAssignManagerModalSubmit"
            >{{ $t("members.SUBMIT") }}</el-button
          >
          <el-button
            class="btn secondary"
            @click="reAssignManagerModalStatus = !reAssignManagerModalStatus"
            >{{ $t("members.CANCEL") }}</el-button
          >
        </div>
      </el-col>
    </el-dialog>
  </div>
</template>

<script>
import { dragscroll } from "vue-dragscroll";

export default {
  directives: {
    dragscroll,
  },
  name: "managers",
  components: {
    loadingEven: require("../even/loading").default,
    relationshipMapping: require("./members-components/relationship-mapping")
      .default,
    orgTab: require("./members-components/org").default,
    downloadProgress: require("../even/download-progress").default,
    Member: require("@/components/content/user-profile-details").default,
  },
  data() {
    return {
      id: "",
      mode: "",
      checked: [],
      checkedData: [],
      subCheckedData: [],
      multipleSelection: [],
      current_page: 1,
      checkedAutoSendInvit: true,
      reAssignManagerModalStatus: false,
      selectedManagerForReAssign: null,
      managerSuggest: [],
      managerSuggest_temp: [],
      assignManager: "",
      manager_assign_disp: "",
      validateForm: {
        pic: "",
        firstname: "",
        lastname: "",
        email: "",
        dispteam: "",
        team_color: "",
        dispboss: "",
        team: "",
        boss: "",
        tmp_boss: "",
        boss_pic: "",
        boss_firstname: "",
        boss_lastname: "",
        language: "th",
        user_type: "user",
        status: "new",
        to_now: "",
        streak_count: 0,
        super_feedback_count: 0,
        medal: [],
        coin: 0,
        gem: 0,
        house: "",
        joined: "",
        joined_tooltips: [],
        dispmanager: "",
        country: "Thailand",
        time_zone: "+07:00",
      },
      dialogFormVisible: false,
      activeProfileTab: "directReports",
      directReportsData: {},
      activeName: "powers",
      switchToArchive: false,
      // powerData: [
      //   {
      //     label: "Empathy",
      //     value: 4361,
      //     maxValue: 4590,
      //     icon: "ic_empathy",
      //   },
      // ],
    };
  },

  created() {
    if (this.updateMember == true) {
      this.$store.dispatch("main/getuser", true).then(() => {
        this.$store.dispatch("membermanager/getMemberManager", this.user);
        this.$store.dispatch("membermanager/getTeamAll", this.user);
        this.$store.commit("authen/setActiveIndex", "2");
      });
    } else {
      this.$store.dispatch("membermanager/getMemberManager", this.user);
      this.$store.dispatch("membermanager/getTeamAll", this.user);
      this.$store.commit("authen/setActiveIndex", "2");
    }

    //this.riskData = mockData;
  },
  watch: {
    inputSearch() {
      this.$store.dispatch("membermanager/searchMembers", this.inputSearch);
    },
    allUser() {
      this.$store.dispatch("membermanager/getMemberManager", this.user);
    },
  },
  computed: {
    inputSearch: {
      get() {
        return this.$store.getters["membermanager/inputSearch"];
      },
      set(value) {
        this.$store.commit("membermanager/setinputSearch", { keyword: value });
      },
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    passProfileToRelationship() {
      let passProfile = {
        firstname: this.validateForm.firstname || "",
        lastname: this.validateForm.lastname || "",
        teamColor: this.validateForm.house_color || "",
        house: this.validateForm.house || "",
        pic: this.validateForm.large_pic || false,
      };
      return passProfile;
    },
    datamembers() {
      return this.$store.getters["newmember/datamembers"];
    },
    managers() {
      return this.$store.getters["membermanager/managers"];
    },
    managersall() {
      return this.$store.getters["membermanager/managersall"];
    },
    team() {
      return this.$store.getters["membermanager/team"];
    },
    page() {
      return this.$store.getters["membermanager/page"];
    },
    results() {
      return this.$store.getters["membermanager/results"];
    },
    subManagerByKey() {
      return this.$store.getters["membermanager/subManagerByKey"];
    },
    membersByKey() {
      return this.$store.getters["membermanager/membersByKey"];
    },
    bossByKey() {
      return this.$store.getters["membermanager/bossByKey"];
    },
    teamByKey() {
      return this.$store.getters["membermanager/teamByKey"];
    },
    loadingManagersTable() {
      return this.$store.getters["membermanager/loadingManagersTable"];
    },
    modalMemberData() {
      return this.$store.getters["newmember/modalMemberData"];
    },
    riskData() {
      return this.$store.getters["newmember/riskData"];
    },
    loadingLoadMoreData() {
      return this.$store.getters["newmember/loadingLoadMoreData"];
    },
    powerData() {
      return this.$store.getters["newmember/powerData"];
    },
    timeZoneOption() {
      return this.$store.getters["newmember/timeZoneOption"];
    },
    locationOption() {
      return this.$store.getters["newmember/locationOption"];
    },
    allUser() {
      return this.$store.getters["main/allUser"];
    },
    updateMember() {
      return this.$store.getters["newmember/updateMember"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  methods: {
    getImgIconOfPower(name) {
      return require("@/assets/images/components/profile/" + name + ".png");
    },
    saveMember() {
      if (
        !this.validateForm.firstname.replace(/ /g, "") ||
        !this.validateForm.lastname.replace(/ /g, "") ||
        !this.validateForm.email.replace(/ /g, "") ||
        !this.validateForm.dispteam.replace(/ /g, "")
      ) {
        this.$message({
          showClose: true,
          message: "Please fill in all the input fields before saving changes",
          type: "error",
        });
        return false;
      } else if (this.validateForm.email == this.validateForm.boss) {
        this.$message({
          showClose: true,
          message: "Not allowed to member and manager to be the same",
          type: "error",
        });
        return false;
      } else if (this.validateForm.dispmanager.replace(/ /g, "")) {
        this.$message({
          showClose: true,
          message: this.validateForm.dispmanager,
          type: "error",
        });
        return false;
      } else {
        if (this.mode == "edit") {
          this.$store
            .dispatch("newmember/updateMember", {
              id: this.id,
              form: this.validateForm,
            })
            .then(() => {
              this.$store.dispatch("newteam/getTeams", this.user);
              this.$store.dispatch("membermanager/getMemberManager", this.user);
            })
            .then(() => {
              this.dialogFormVisible = false;
              //this.cancelAdd();
            });
          this.$message({
            type: "success",
            message: "Member profile has been updated",
          });
        }
      }
    },
    inviteMember(email) {
      this.$confirm(
        "Are you sure you want to send an invitation email?",
        "Confirm",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch("newmember/inviteMember", email);
          this.dialogFormVisible = false;
          this.cancelAdd();
        })
        .then(() => {
          this.$store.dispatch("membermanager/getMemberManager", this.user);
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Invitation sent successfully",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Invitation email canceled",
          });
        });
    },
    querySearchTeam(queryString, cb) {
      //var links = this.links;
      var links = this.team;
      var results = queryString
        ? links.filter(this.createFilterTeam(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilterTeam(queryString) {
      return (link) => {
        return link.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelectTeam(item) {
      item.email = this.validateForm.boss;
      this.validateForm.dispmanager = "";
      if (this.validateForm.email && item.email) {
        // check loop
        let arrUserRole = [];
        let bossTemp = "";
        let chkLoopErr = false;
        arrUserRole[this.validateForm.email] = this.validateForm.email;
        arrUserRole[item.email] = item.email;
        let emailKey = item.email.replace(/\./g, "||");
        bossTemp =
          this.membersByKey[emailKey] && this.membersByKey[emailKey].boss
            ? this.membersByKey[emailKey].boss
            : "";
        if (bossTemp) {
          do {
            if (arrUserRole[bossTemp]) {
              chkLoopErr = true;
            } else {
              arrUserRole[bossTemp] = bossTemp;
              let bossKey = bossTemp.replace(/\./g, "||");
              bossTemp =
                this.membersByKey[bossKey] && this.membersByKey[bossKey].boss
                  ? this.membersByKey[bossKey].boss
                  : "";
              if (bossTemp && arrUserRole[bossTemp]) {
                chkLoopErr = true;
              }
            }
          } while (
            bossTemp &&
            arrUserRole[bossTemp] == undefined &&
            chkLoopErr == false
          );
        }
        if (chkLoopErr) {
          this.validateForm.dispmanager =
            "⚠️ Managers cannot report to their direct report or below";
        }
        // End Check Loop
      }
      if (
        this.validateForm.boss &&
        item.key &&
        this.validateForm.dispmanager == ""
      ) {
        let teamMember = _.filter(this.datamembers["membersall"], {
          team: item.key,
        });
        if (teamMember.length > 0) {
          let bosscheck = [];
          for (const i in teamMember) {
            if (
              teamMember[i]["email"] !== this.validateForm.email &&
              teamMember[i]["boss"]
            ) {
              bosscheck[teamMember[i]["boss"]] = teamMember[i]["boss"];
            }
          }
          if (Object.keys(bosscheck).length >= 1) {
            let emailKey = item.email.replace(/\./g, "||");
            if (
              bosscheck[item.email] == undefined &&
              bosscheck[this.validateForm.email] == undefined
            ) {
              if (
                this.membersByKey[emailKey] &&
                this.membersByKey[emailKey].boss &&
                bosscheck[this.membersByKey[emailKey].boss]
              ) {
              } else {
                this.validateForm.dispmanager =
                  "⚠️ Managers must have their own team";
              }
            }
          }
        }
      }
      let color = item.color ? item.color.replace(/#/g, "") : "";
      this.validateForm.team = item.key;
      this.validateForm.team_color = color;
    },
    handleSelectManager(item) {
      this.validateForm.dispmanager = "";
      if (this.validateForm.email) {
        // check loop
        let arrUserRole = [];
        let bossTemp = "";
        let chkLoopErr = false;
        arrUserRole[this.validateForm.email] = this.validateForm.email;
        arrUserRole[item.email] = item.email;
        let emailKey = item.email.replace(/\./g, "||");
        bossTemp =
          this.membersByKey[emailKey] && this.membersByKey[emailKey].boss
            ? this.membersByKey[emailKey].boss
            : "";
        if (bossTemp) {
          do {
            if (arrUserRole[bossTemp]) {
              chkLoopErr = true;
            } else {
              arrUserRole[bossTemp] = bossTemp;
              let bossKey = bossTemp.replace(/\./g, "||");
              bossTemp =
                this.membersByKey[bossKey] && this.membersByKey[bossKey].boss
                  ? this.membersByKey[bossKey].boss
                  : "";
              if (bossTemp && arrUserRole[bossTemp]) {
                chkLoopErr = true;
              }
            }
          } while (
            bossTemp &&
            arrUserRole[bossTemp] == undefined &&
            chkLoopErr == false
          );
        }
        if (chkLoopErr) {
          this.validateForm.dispmanager =
            "⚠️ Managers cannot report to their direct report or below";
        }
        // End Check Loop
      }
      if (this.validateForm.team && this.validateForm.dispmanager == "") {
        let teamMember = _.filter(this.datamembers["membersall"], {
          team: this.validateForm.team,
        });
        if (teamMember.length > 0) {
          let bosscheck = [];
          for (const i in teamMember) {
            if (
              teamMember[i]["email"] !== this.validateForm.email &&
              teamMember[i]["boss"]
            ) {
              bosscheck[teamMember[i]["boss"]] = teamMember[i]["boss"];
            }
          }
          if (Object.keys(bosscheck).length >= 1) {
            let emailKey = item.email.replace(/\./g, "||");
            if (
              bosscheck[item.email] == undefined &&
              bosscheck[this.validateForm.email] == undefined
            ) {
              if (
                this.membersByKey[emailKey] &&
                this.membersByKey[emailKey].boss &&
                bosscheck[this.membersByKey[emailKey].boss]
              ) {
              } else {
                this.validateForm.dispmanager =
                  "⚠️ Managers must have their own team";
              }
            }
          }
        }
      }
      this.validateForm.boss = item.email;
      this.validateForm.boss_pic = item.pic;
      this.validateForm.boss_firstname = item.firstname;
      this.validateForm.boss_lastname = item.lastname;
    },
    handleInputTeam(value) {
      if (!value) {
        this.validateForm.team_color = "";
        this.validateForm.dispmanager = "";
      }
    },
    querySearchManager(queryString, cb) {
      var links = this.datamembers["membersall"];
      var results = links.filter(this.createFilterManager(queryString));
      cb(results);
    },
    createFilterManager(queryString) {
      return (link) => {
        if (
          link.firstname.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0 &&
          link.email.toLowerCase() !== this.validateForm.email.toLowerCase()
        ) {
          return true;
        } else if (
          link.lastname.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0 &&
          link.email.toLowerCase() !== this.validateForm.email.toLowerCase()
        ) {
          return true;
        } else if (
          link.email.toLowerCase().indexOf(queryString.toLowerCase()) === 0 &&
          link.email.toLowerCase() !== this.validateForm.email.toLowerCase()
        ) {
          return true;
        }
      };
    },
    cancelAdd() {
      this.validateForm.large_pic = "";
      this.validateForm.firstname = "";
      this.validateForm.lastname = "";
      this.validateForm.email = "";
      this.validateForm.dispteam = "";
      this.validateForm.team_color = "";
      this.validateForm.dispboss = "";
      this.validateForm.team = "";
      this.validateForm.boss = "";
      this.validateForm.tmp_boss = "";
      this.validateForm.boss_pic = "";
      this.validateForm.boss_firstname = "";
      this.validateForm.boss_lastname = "";
      this.validateForm.language = "th";
      this.validateForm.user_type = "user";
      // this.validateForm.invite = true;
      this.validateForm.status = "new";
      this.validateForm.to_now = "";
      this.validateForm.streak_count = 0;
      this.validateForm.super_feedback_count = 0;
      this.validateForm.medal = [];
      this.validateForm.coin = 0;
      this.validateForm.gem = 0;
      this.validateForm.house = "";
      this.validateForm.joined = "";
      this.validateForm.joined_tooltips = [];
      this.validateForm.dispmanager = "";
      this.switchToArchive = false;
      this.activeName = "powers";
      this.directReportsData = {};
      this.activeProfileTab = "directReports";
      this.$store.commit("newmember/setModalMemberData", []);

      let check = this.checked;
      for (const i in check) {
        this.$set(this.checked, i, false);
      }
      this.checkedData = [];
      this.subCheckedData = [];
    },
    archiveMemberClick() {
      this.$confirm(
        "Are you sure you want to archive this member account?",
        "Warning",
        {
          confirmButtonText: "Yes, confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch("newmember/archiveMember", this.id);
          this.dialogFormVisible = false;
          this.cancelAdd();
        })
        .then(() => {
          this.$store.dispatch("newteam/getTeams", this.user);
          this.$store.dispatch("membermanager/getMemberManager", this.user);
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Member account archived",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    cancelDialog() {
      this.directReportsData = {};
      this.$store.commit("newmember/setModalMemberData", []);
      this.$store.dispatch("newmember/clearDate");
    },
    getImgUrl(pic) {
      var images = require.context("../../assets/images/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    getImgUrlMem(pic) {
      var images = require.context(
        "../../assets/images/members/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    getImgUrlSet(pic) {
      var images = require.context(
        "../../assets/images/settings/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    rowClickEdit(row, column, event) {
      if (column.columnKey && column.columnKey == "memberCheckbox") {
      } else {
        const item = row;
        if (item.introduce) this.validateForm.introduce = item.introduce;
        if(item.culture_add_percentile)this.validateForm.culture_add_percentile = item.culture_add_percentile
        this.id = item.key;
        this.mode = "edit";
        this.validateForm.large_pic = item.large_pic;
        this.validateForm.firstname = item.firstname;
        this.validateForm.lastname = item.lastname;
        this.validateForm.email = item.email;
        this.validateForm.dispteam = item.team_name;
        let colorCode = item.team_color
          ? item.team_color.replace(/#/g, "")
          : "";
        this.validateForm.team_color = colorCode;
        this.validateForm.team = item.team;
        //this.validateForm.team_name = item.team_name;
        this.validateForm.boss = item.boss;
        this.validateForm.tmp_boss = item.boss;
        this.validateForm.boss_pic = item.boss_pic;
        this.validateForm.dispboss = item.boss_name;
        this.validateForm.boss_firstname = item.boss_firstname;
        this.validateForm.boss_lastname = item.boss_lastname;
        this.validateForm.language = item.language;
        this.validateForm.user_type = item.user_type;

        this.validateForm.country = item.country ? item.country : "TH";
        let timezone = "";
        if (item.timezone) {
          if (item.timezone >= 0) {
            if (item.timezone < 10) {
              timezone =
                "+0" + item.timezone.toFixed(2).toString().replace(".", ":");
            } else {
              timezone =
                "+" + item.timezone.toFixed(2).toString().replace(".", ":");
            }
          } else {
            if (item.timezone < 10) {
              timezone =
                "-0" +
                item.timezone
                  .toFixed(2)
                  .toString()
                  .replace("-", "")
                  .replace(".", ":");
            } else {
              timezone = item.timezone.toFixed(2).toString().replace(".", ":");
            }
          }
        } else {
          timezone = "+07.00";
        }
        this.validateForm.time_zone = timezone;
        // this.validateForm.invite = false;
        this.validateForm.status = item.status;
        this.validateForm.to_now = item.to_now;
        this.validateForm.streak_count = item.streak_count
          ? item.streak_count
          : 0;
        this.validateForm.super_feedback_count = item.super_feedback_count
          ? item.super_feedback_count
          : 0;
        this.validateForm.medal = item.medal ? item.medal : [];
        this.validateForm.coin = item.coin;
        this.validateForm.gem = item.gem;
        this.validateForm.house = item.house;
        this.validateForm.joined = item.joined ? item.joined : "";
        this.validateForm.joined_tooltips =
          item.joined_tooltips && item.joined_tooltips.length > 0
            ? item.joined_tooltips[0]
            : [];
        if (item.order_join) {
          let joinTotal = Object.keys(this.datamembers["membersall"]).filter(
            (k) => this.datamembers["membersall"][k].order_join
          ).length;
          this.validateForm.joined_tooltips["percent"] = (
            ((joinTotal - item.order_join) / joinTotal) *
            100
          ).toFixed();
        }
        this.validateForm.dispmanager = "";
        let directReportsData = {};
        directReportsData.total = 0;
        directReportsData.directReport = [];
        let directReport = _.filter(this.datamembers["membersall"], {
          boss: item.email,
        });
        if (directReport.length > 0) {
          this.directReportsData.total = directReport.length;
          this.directReportsData.directReport = directReport;
          // this.activeProfileTab = 'directReports'
        } else {
          // this.activeProfileTab = 'information'
          this.directReportsData = directReportsData;
        }
        this.$store.dispatch("newmember/getModalMemberData", item);
        this.activeName = "powers";
        this.activeProfileTab = "directReports";
        this.switchToArchive = false;
        this.dialogFormVisible = true;
        this.$store.dispatch("newmember/getRisk", item);
        this.$store.dispatch("newmember/getStarPerformer", item);
        this.$store.dispatch("newmember/getHoliday", item);
        this.$store.dispatch("newmember/getPowerData", item);
        this.$store.dispatch("newmember/getDataHerepoint", item.email);
        this.$store.dispatch("newmember/getDailyStatus", item).then(() => {
          setTimeout(() => {
            var container = this.$el.querySelector("#riskBox");
            container.scrollLeft = container.scrollWidth;
          }, 1000);
        });
      }
    },
    tableRowStyle({ row, rowIndex }) {
      return "cursor: pointer;";
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.$store.dispatch("membermanager/currentChange", val);
    },
    membersChecked(key) {
      let count = Object.keys(this.checked).filter(
        (k) => this.checked[k] === true
      ).length;
      if (this.checked["key_" + key] === true) {
        this.checkedData.push(this.membersByKey[key]);

        let email_replace = key.replace(/\|\|/g, ".");
        let subMember = this.subManagerByKey[email_replace];
        if (subMember) {
          for (const i in subMember) {
            this.subCheckedData.push(this.membersByKey[subMember[i].key]);
          }
        }
      } else {
        const index = this.checkedData.findIndex((obj) => obj.key === key);
        this.checkedData.splice(index, 1);

        let email_replace = key.replace(/\|\|/g, ".");
        let arrSub = _.filter(this.subCheckedData, { boss: email_replace });
        if (arrSub.length > 0) {
          for (const x in arrSub) {
            const indexSub = this.subCheckedData.findIndex(
              (obj) => obj.key === arrSub[x].key
            );
            this.subCheckedData.splice(indexSub, 1);
          }
        }
      }
    },
    sortBy(type) {
      if (type == "name") {
        document.getElementById("managerSortBy").innerHTML = "Sort by Name";
      } else if (type == "direct") {
        document.getElementById("managerSortBy").innerHTML =
          "Sort by Direct Reports";
      }
      this.$store.dispatch("membermanager/sortBy", type);
    },
    tableHeaderStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 5) {
        return "padding-right: 10px;";
      }
    },
    renderDirectReportPic(index) {
      if (index == 0) {
        return "";
      } else {
        return `left: ${index * -10}px; position: relative`;
      }
    },
    renderDirectReportWidth(index) {
      if (index == 0) {
        return "";
      } else if (index < 5) {
        return `width: ${12 + index * 22}px;`;
      }
      return `width: ${12 + 4 * 22}px;`;
    },
    renderSelectedPic(index) {
      if (index == 0) {
        return "";
      } else {
        return `left: ${index * -10}px; position: relative`;
      }
    },
    cancelReAssignManagerModal() {
      this.managerSuggest = [];
      this.managerSuggest_temp = [];
      this.assignManager = "";
      this.selectedManagerForReAssign = null;
      this.manager_assign_disp = "";
    },
    reAssignManagerModalClick() {
      let memberData = this.subCheckedData;
      this.managerSuggest = [];
      this.managerSuggest_temp = [];
      this.assignManager = "";
      this.selectedManagerForReAssign = null;
      for (const i in memberData) {
        if (this.managerSuggest.length < 8) {
          if (memberData[i].boss) {
            /*direc manager*/
            let bossKeyID = memberData[i].boss.replace(/\./g, "||");
            let bigBossKeyID = this.membersByKey[bossKeyID].boss.replace(
              /\./g,
              "||"
            );
            if (this.membersByKey[bossKeyID].boss) {
              let chk_managerExist = _.filter(this.managerSuggest, {
                key: bigBossKeyID,
              });
              let chk_duplicate = _.filter(memberData, { key: bigBossKeyID });
              if (chk_managerExist.length == 0 && chk_duplicate.length == 0) {
                this.managerSuggest.push(this.membersByKey[bigBossKeyID]);
                this.managerSuggest_temp.push(this.membersByKey[bigBossKeyID]);
              }
            }

            /*share direct manager*/
            if (this.bossByKey[bossKeyID]) {
              let shareManager = _.filter(this.managersall, {
                boss: memberData[i].boss,
              });
              if (shareManager.length > 0) {
                for (const j in shareManager) {
                  if (this.managerSuggest.length < 8) {
                    if (this.bossByKey[shareManager[j].key]) {
                      let chk_managerExist = _.filter(this.managerSuggest, {
                        key: shareManager[j].key,
                      });
                      let chk_duplicate = _.filter(memberData, {
                        key: shareManager[j].key,
                      });
                      if (
                        chk_managerExist.length == 0 &&
                        chk_duplicate.length == 0
                      ) {
                        this.managerSuggest.push(
                          this.membersByKey[shareManager[j].key]
                        );
                        this.managerSuggest_temp.push(
                          this.membersByKey[shareManager[j].key]
                        );
                      }
                    }
                  } else {
                    return;
                  }
                }
              }
            }
          }
        } else {
          return;
        }
      }
    },
    assignManagerActiveClick(item, index) {
      this.selectedManagerForReAssign = index;
      this.assignManager = item.email;
    },
    reAssignManagerModalSubmit() {
      if (!this.assignManager) {
        this.$message({
          showClose: true,
          message: "Please select manager to assign.",
          type: "error",
        });
        return false;
      } else {
        this.$confirm(
          "Are you sure you want to assign manager to this member?",
          "Warning",
          {
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.$store.dispatch("membermanager/assignManagerSubmit", {
              memberData: this.subCheckedData,
              manager: this.assignManager,
            });
            let check = this.checked;
            for (const i in check) {
              this.$set(this.checked, i, false);
            }
            this.checkedData = [];
            this.subCheckedData = [];
            this.cancelReAssignManagerModal();
            this.reAssignManagerModalStatus = false;
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "Assign manager success",
            });
          })
          .then(() => {
            this.$store.dispatch("newmember/getTeamAll", this.user);
            this.$store.dispatch("newmember/getMember", this.user);
            this.$store.dispatch("newteam/getTeams", this.user);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Assign manager canceled",
            });
          });
      }
    },
    handleInputManager(value) {
      if (!value) {
        this.validateForm.boss = "";
        this.validateForm.boss_pic = "";
        this.validateForm.boss_firstname = "";
        this.validateForm.boss_lastname = "";
        this.validateForm.dispmanager = "";
      }
    },
    handleInputManagerAssign(queryString) {
      this.assignManager = "";
      this.selectedManagerForReAssign = null;
      if (queryString) {
        this.managerSuggest = [];
        let arrData = [];
        var links = this.managersall;
        var results = queryString
          ? links.filter(this.createFilterManager(queryString))
          : links;
        if (results.length > 0) {
          for (const i in results) {
            let emailKey = results[i].email.replace(/\./g, "||");
            let chk_self = _.filter(this.subCheckedData, { key: emailKey });
            if (
              arrData.length < 8 &&
              chk_self.length == 0 &&
              this.membersByKey[emailKey]
            ) {
              arrData.push(this.membersByKey[emailKey]);
            }
          }
          this.managerSuggest = arrData;
        }
      } else {
        this.managerSuggest = this.managerSuggest_temp;
      }
    },
    createFilterManager(queryString) {
      return (link) => {
        if (
          link.firstname.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        ) {
          return true;
        } else if (
          link.lastname.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        ) {
          return true;
        } else if (
          link.email.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        ) {
          return true;
        }
      };
    },
    loadMoreData() {
      this.$store.dispatch("newmember/getDailyStatus", this.validateForm);
    },
    setBarWidth(value, max) {
      let percentage = (value / max) * 100;
      let width = (450 / 100) * percentage;
      return width || "0";
    },
  },
};
</script>

<style lang="scss" scoped>
#tabManagers >>> .divContentProfileModal {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.txtArchivedModal {
  font-size: 16px;
  color: #494949;
  text-decoration: underline;
  cursor: pointer;
}
.second-column {
  background-color: #f8f8f8;
  height: 84vh;
  min-height: 847px;
  max-height: 1200px;
}
.txtHeaderStyle {
  margin: 0px;
  padding-bottom: 8px;
  font-size: 16px;
  color: #2d2e36;
  font-weight: 700;
}
.btnArchiveModal {
  background-color: #f44336;
  border-color: #f44336;
  color: #ffffff;
  width: 155px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.btnArchiveModal:hover {
  background-color: #f44336;
  border-color: #f44336;
  color: #ffffff;
  opacity: 0.6;
}
.btnAddMemberModal {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  width: 176px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.btnAddMemberModal:hover {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  opacity: 0.6;
}
.btnInviteMemberModal {
  width: 176px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.btnCancelArchiveModal {
  width: 122px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.txtHeadSquareNumber {
  font-size: 10px;
  color: #ffffff;
}
.divContent {
  background: #ffffff;
}
.el-submenu {
  width: 220px;
}
.view-member {
  border: 1px solid #ffffff;
}
.phase-header {
  width: 200px;
  height: 200px;
  background: #222222;
}
.el-dropdown-menu__item {
  font-size: 14px;
  font-weight: 500;
  color: #585858;
}
li.el-dropdown-menu__item:hover {
  background-color: #6c30cc;
  color: #ffffff;
}
div.el-dropdown {
  padding-left: 0px;
}
.bg-hover-barken-54279B {
  background-color: #54279b;
  color: #fff;
}
.bg-hover-barken-54279B:hover {
  background-color: #3f1e74;
}
.divActionHeader {
  margin-right: 30px;
  display: flex;
  flex: 1;
  justify-content: flex-end;
}
.viewMember {
  border: 1px solid #c4c4c4;
}
.selectionmenu .viewMember {
  border: 1px solid rgb(108, 48, 204);
}
.first-column-modal {
  padding: 40px;
  padding-right: 30px;
  background-color: #f8f8f8;
  height: 100%;
}
.second-column-modal {
  padding: 40px;
  height: 100%;
}
.second-column-modal .btn {
  padding: 16px 32px;
  color: #fff;
  font-weight: 700;
}
.second-column-modal .btn:hover {
  opacity: 0.7;
}
.second-column-modal .secondary {
  background-color: #d1d1d1;
}
.second-column-modal .primary {
  background-color: #32c2d5;
}
.second-column-modal > .grid-2 {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 20px;
  width: 100%;
}
.second-column-modal > .grid-2 > .card {
  transition: 0.3s;
  padding: 24px;
  background-color: #f7f7f7;
  border: 1px solid #f7f7f7;
}
.second-column-modal > .grid-2 > .active-card {
  background-color: #e8e8e8;
  border: 1px solid #c7c7c7;
}
.height-bind {
  margin-top: -10px;
  height: 52px;
}
</style>   
<style lang="scss">
#tabManagers .el-checkbox__inner {
  width: 24px;
  height: 24px;
  border: 1px solid #c6c6c6;
  align-items: center;
}
#tabManagers .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #5423a2;
  border: 1px solid #5423a2;
  align-items: center;
}
#tabManagers .el-table .cell {
  line-height: 20px;
}
#tabManagers .el-table th > .cell {
  font-weight: 700;
}
#tabManagers .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f5f5f5;
}
#tabManagers .el-table__row {
  cursor: pointer;
}
#tabManagers span.el-checkbox__inner::after {
  border: 3px solid #fff;
  border-left: 0;
  border-top: 0;
  top: 2px;
  left: 7px;
  width: 5px;
  height: 13px;
}
#tabManagers label.el-checkbox {
  line-height: 24px;
}
#tabManagers .el-checkbox__input {
  zoom: 1 !important;
}
#tabManagers .el-dialog {
  width: 1100px;
}
#tabManagers .el-dialog__header {
  padding: 0px;
}
#tabManagers .el-dialog__body {
  padding: 0px;
  height: 84vh;
  min-height: 847px;
  max-height: 1200px;
}
#tabHeaderStyle .el-tabs__header {
  margin: 0 0 4px;
}
#tabManagers .el-tabs__active-bar {
  background-color: #32c2d5 !important;
  /* height: 4px; */
}
#tabManagers .el-dialog__headerbtn {
  font-size: 26px;
}
#tabManagers .profileform .el-input__inner {
  height: 46px;
  line-height: 46px;
  font-size: 17px;
  border: none;
  padding: 0 32px;
}
#tabManagers .profileform .el-input-group__prepend {
  border: none;
  background: #ffffff;
}
#tabManagers .profileform .managerfield .el-input__inner {
  height: 80px;
  padding: 0 16px 16px 42px;
}
#tabManagers .profileform .teamfield .el-input__inner {
  height: 60px;
  background: #e4e4e4;
  border-left-width: 7px;
  border-left-style: solid;
  /* border-left-color: #6c30cc; */
  padding: 0 32px;
}
#tabManagers .profileform .managerfield .el-input-group__prepend {
  width: 0;
  padding: 0;
}
#tabManagers .profileform .rolefield .el-input__inner,
#tabManagers .profileform .langfield .el-input__inner {
  height: 42px;
}
#tabManagers .profileform .el-input.is-disabled .el-input__inner {
  background-color: #eee;
  border-color: #eee;
  color: #888;
}
#membersContainer #tabManagers .el-tabs__item.is-active,
#membersContainer #tabManagers .el-tabs__item {
  font-size: 16px;
  height: 44px;
}
#membersContainer #tabManagers #modal_profile .el-tabs__item {
  width: 200px;
}
#tabManagers .profileform .border-left-color- .el-input__inner {
  border-left-color: #747474;
}
#tabManagers .el-table td {
  padding: 12px 0;
}
#tabManagers .profileform .border-left-color-6C30CC .el-input__inner {
  border-left-color: #6c30cc;
}
#tabManagers .profileform .border-left-color-4F86C6 .el-input__inner {
  border-left-color: #4f86c6;
}
#tabManagers .profileform .border-left-color-50B0C6 .el-input__inner {
  border-left-color: #50b0c6;
}
#tabManagers .profileform .border-left-color-379392 .el-input__inner {
  border-left-color: #379392;
}
#tabManagers .profileform .border-left-color-68D5B5 .el-input__inner {
  border-left-color: #68d5b5;
}
#tabManagers .profileform .border-left-color-EE7885 .el-input__inner {
  border-left-color: #ee7885;
}
#tabManagers .profileform .border-left-color-C99EC4 .el-input__inner {
  border-left-color: #c99ec4;
}
#tabManagers .profileform .border-left-color-84B1ED .el-input__inner {
  border-left-color: #84b1ed;
}
#tabManagers .profileform .border-left-color-31AADE .el-input__inner {
  border-left-color: #31aade;
}
#tabManagers .profileform .border-left-color-F0DC05 .el-input__inner {
  border-left-color: #f0dc05;
}
#tabManagers .profileform .border-left-color-E63A40 .el-input__inner {
  border-left-color: #e63a40;
}
#archivedModal .el-dialog__body {
  min-height: 980px;
  height: auto;
}
</style>